module.exports = __webpack_public_path__ + "media/configurations/O-SX-SX-O-f230700f.png";